import USDTIcon from "@spheron/ui-library/dist/assets/crypto-social/Tether.svg?url";
import USDCIcon from "@spheron/ui-library/dist/assets/crypto-social/Usdc.svg?url";
import DaiIcon from "@spheron/ui-library/dist/assets/crypto-social/Dai.svg?url";
import WethIcon from "@spheron/ui-library/dist/assets/crypto-social/Weth.svg?url";
import SPONIcon from "@/assets/icons/spon.svg?url";
import uSponIcon from "@/assets/icons/dollar.svg?url";
import uSponWhiteIcon from "@/assets/icons/dollar-white.svg?url";
import { addressMap } from "@/contracts/addresses";
import { createThirdwebClient } from "thirdweb";
import { THIRD_WEB_CLIENT_ID } from "./nft";

// Testnet URLs
export const SPHERON_DEVNET_URL =
  "https://spheron-devnet-eth.rpc.caldera.xyz/http";
export const SPHERON_TESTNET_EXPLORER_URL = "https://sepolia.arbiscan.io/";

export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://fizz.spheron.network"
    : // ? "https://fizz-node-app-git-${BRANCH_NAME}-spheron.vercel.app"
      "http://localhost:3007";

export const SERVICE_API_URL = "https://api-v2.spheron.network";

export const SPHERON_DEVNET_RPC_URL =
  "https://base-sepolia.g.alchemy.com/v2/vN6ZeMQVQEjbGURcN5_vD_oVFQ_u6pQ9";

export const SPHERON_DEVNET_WSS_URL =
  "wss://base-sepolia.g.alchemy.com/v2/vN6ZeMQVQEjbGURcN5_vD_oVFQ_u6pQ9";

export const SPHERON_MAINNET_RPC_URL =
  "https://base-mainnet.g.alchemy.com/v2/MQ_PUPS0mFL_d92dsAneq";

export const SPHERON_MAINNET_WSS_URL =
  "wss://base-mainnet.g.alchemy.com/v2/MQ_PUPS0mFL_d92dsAneq";

export const RPC_MAP: Record<NetworkType, Record<string, string>> = {
  testnet: {
    http: SPHERON_DEVNET_RPC_URL,
    wss: SPHERON_DEVNET_WSS_URL,
  },
  mainnet: {
    http: SPHERON_MAINNET_RPC_URL,
    wss: SPHERON_MAINNET_WSS_URL,
  },
};

export const BASE_MAINNET_PUBLIC_RPC_HTTP_URL = "https://mainnet.base.org";
// export const BASE_MAINNET_PUBLIC_RPC_HTTP_URL = "https://responsive-capable-dream.base-mainnet.quiknode.pro/e52970b08f776bcf5b0a7d6267d7331920a71f00";

export const SPHERON_DEVNET_EXPLORER_URL =
  "https://spheron-devnet-eth.explorer.caldera.xyz/";

export const REGISTER_COST_ETH = "0.02";
export const REGISTER_RECIPIENT_ADDRESS =
  process.env.NEXT_PUBLIC_REGISTER_RECIPIENT_ADDRESS ||
  "0xeAEdc18077456629104788934020D8E7Da74C996";
export const BNB_SAFE_WALLET =
  process.env.NEXT_PUBLIC_BNB_SAFE_WALLET ||
  "0xA5309e7c47042667bCa04e1425569af60297171c";
export const ARB_SAFE_WALLET =
  process.env.NEXT_PUBLIC_ARB_SAFE_WALLET ||
  "0x8dC98318Acd7a91fbdF1766aF8f13C01FD6f26BE";
export const BASE_SAFE_WALLET =
  process.env.NEXT_PUBLIC_BASE_SAFE_WALLET ||
  "0xe289279c814b16Ca2Bc923A24F788e3A70566862";
export const ZKSYNC_SAFE_WALLET =
  process.env.NEXT_PUBLIC_ZKSYNC_SAFE_WALLET ||
  "0x3087e1e9EACC6F681d63E9aa7e8d74A9c302F177";
export const ETH_SAFE_WALLET =
  process.env.NEXT_PUBLIC_ETH_SAFE_WALLET ||
  "0x7B036CCFe31F800368999D29675D26282A90cDcC";

export const SUBGRAPH_API_KEY = process.env.NEXT_PUBLIC_SUBGRAPH_API_KEY || "";

export const FIZZUP_SCRIPT_URL =
  process.env.NEXT_PUBLIC_VERCEL_ENV !== "production"
    ? "https://spheron-release.s3.amazonaws.com/scripts/fizz/fizzup.sh"
    : "https://spheron-release.s3.amazonaws.com/scripts/prod/fizzup.sh";

export interface INetwork {
  chainId: number;
  chainName: string;
  rpcUrls: string[];
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  blockExplorerUrls: string[];
  tokenAddress?: string;
}

export type NetworkType = "testnet" | "mainnet";

export const networkMap: Record<NetworkType, INetwork> = {
  // testnet: {
  //   chainId: 89138,
  //   chainName: "Spheron Devnet",
  //   rpcUrls: ["https://spheron-devnet-eth.rpc.caldera.xyz/http"],
  //   nativeCurrency: {
  //     name: "Ethereum",
  //     symbol: "ETH",
  //     decimals: 18,
  //   },
  //   blockExplorerUrls: ["https://spheron-devnet-eth.explorer.caldera.xyz/"],
  // },
  testnet: {
    chainId: 84532,
    chainName: "Base Sepolia",
    rpcUrls: [SPHERON_DEVNET_RPC_URL],
    nativeCurrency: {
      name: "Sepolia Ether",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://sepolia.basescan.org/"],
  },
  mainnet: {
    chainId: 8453,
    chainName: "Base Mainnet",
    rpcUrls: [SPHERON_MAINNET_RPC_URL],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://base.blockscout.com/"],
  },
};

export const networkType: NetworkType =
  (process.env.NEXT_PUBLIC_NETWORK_TYPE as NetworkType) || "mainnet";

export type MainnetNetworkType = "base" | "eth" | "arbitrum" | "zksync" | "bnb";

export const mainnetNetworkMap: Record<MainnetNetworkType, INetwork> = {
  base: {
    chainId: 8453,
    chainName: "Base Mainnet",
    rpcUrls: ["https://mainnet.base.org"],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://basescan.org"],
  },
  // base: {
  //   chainId: 84532,
  //   chainName: "Base Sepolia",
  //   rpcUrls: [SPHERON_DEVNET_RPC_URL],
  //   nativeCurrency: {
  //     name: "Sepolia Ether",
  //     symbol: "ETH",
  //     decimals: 18,
  //   },
  //   blockExplorerUrls: ["https://sepolia.basescan.org"],
  // },
  eth: {
    chainId: 1,
    chainName: "Ethereum Mainnet",
    rpcUrls: ["https://ethereum-rpc.publicnode.com"],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://etherscan.io"],
  },
  arbitrum: {
    chainId: 42161,
    chainName: "Arbitrum One",
    rpcUrls: ["https://arb1.arbitrum.io/rpc"],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://arbiscan.io"],
  },
  // arbitrum: {
  //   chainId: 421614,
  //   chainName: "Arbitrum Sepolia",
  //   rpcUrls: ["https://sepolia-rollup.arbitrum.io/rpc"],
  //   nativeCurrency: {
  //     name: "Ethereum",
  //     symbol: "ETH",
  //     decimals: 18,
  //   },
  //   blockExplorerUrls: ["https://sepolia.arbiscan.io/"],
  // },
  zksync: {
    chainId: 324,
    chainName: "zkSync Era Mainnet",
    rpcUrls: ["https://mainnet.era.zksync.io"],
    nativeCurrency: {
      name: "Ethereum",
      symbol: "ETH",
      decimals: 18,
    },
    blockExplorerUrls: ["https://explorer.zksync.io"],
  },
  bnb: {
    chainId: 56,
    chainName: "Binance Smart Chain",
    rpcUrls: ["https://bsc-dataseed.bnbchain.org"],
    nativeCurrency: {
      name: "Binance Coin",
      symbol: "BNB",
      decimals: 18,
    },
    blockExplorerUrls: ["https://bscscan.com"],
    tokenAddress: "0x2170Ed0880ac9A755fd29B2688956BD959F933F8",
  },
};

export interface IToken {
  id: number;
  name: string;
  symbol: string;
  decimal: number;
  address: string;
  logo: any;
}

export const tokenMap: Record<NetworkType, IToken[]> = {
  testnet: [
    {
      id: 1,
      name: "Tether USD Test Token",
      symbol: "USDT",
      decimal: 6,
      address: addressMap.testnet.usdt,
      logo: USDTIcon,
    },
    {
      id: 2,
      name: "DAI Test Token",
      symbol: "DAI",
      decimal: 18,
      address: addressMap.testnet.dai || "",
      logo: DaiIcon,
    },
    {
      id: 3,
      name: "Test Token USD Coin",
      symbol: "USDC",
      decimal: 6,
      address: addressMap.testnet.usdc || "",
      logo: USDCIcon,
    },
    {
      id: 4,
      name: "Wrapped ETH Test Token",
      symbol: "WETH",
      decimal: 18,
      address: addressMap.testnet.weth || "",
      logo: WethIcon,
    },
    {
      id: 5,
      name: "Spheron Credit Token",
      symbol: "CST",
      decimal: 6,
      address: addressMap.testnet.cst || "",
      logo: USDTIcon,
    },
    {
      id: 6,
      name: "uSPON",
      symbol: "uSPON",
      decimal: 6,
      address: addressMap.testnet.uspon,
      // TODO: update logo
      logo: uSponIcon,
    },
    {
      id: 7,
      name: "SPON",
      symbol: "SPON",
      decimal: 18,
      address: addressMap.testnet.spon,
      // TODO: update logo
      logo: SPONIcon,
    },
  ],
  mainnet: [
    {
      id: 1,
      name: "USDT",
      symbol: "USDT",
      decimal: 6,
      address: addressMap.mainnet.usdt,
      logo: USDTIcon,
    },
    {
      id: 2,
      name: "USDC",
      symbol: "USDC",
      decimal: 6,
      address: addressMap.mainnet.usdc,
      logo: USDCIcon,
    },
    {
      id: 3,
      name: "uSPON",
      symbol: "uSPON",
      decimal: 6,
      address: addressMap.mainnet.uspon,
      // TODO: update logo
      logo: uSponIcon,
    },
    {
      id: 4,
      name: "SPON",
      symbol: "SPON",
      decimal: 18,
      address: addressMap.mainnet.spon,
      // TODO: update logo
      logo: SPONIcon,
    },
  ],
};

export enum OperatingSystem {
  Mac = "macos",
  Linux = "linux",
  Windows = "windows",
}

export enum Resource {
  RAM = "RAM",
  STORAGE = "Storage",
  GPU = "GPU",
  CPU = "CPU",
}

export const GPU_RESOURCE_LIST = [
  Resource.RAM,
  Resource.STORAGE,
  Resource.GPU,
  Resource.CPU,
];

export const CPU_RESOURCE_LIST = [
  Resource.RAM,
  Resource.STORAGE,
  Resource.CPU,
] as const;

export const MAX_RESOURCE_UNITS = {
  [Resource.GPU]: 8,
  [Resource.CPU]: 32,
  [Resource.RAM]: 128,
  [Resource.STORAGE]: 2000,
} as const;

export const MIN_RESOURCE_UNITS = {
  [Resource.GPU]: 1,
  [Resource.CPU]: 4,
  [Resource.RAM]: 8,
  [Resource.STORAGE]: 100,
} as const;

export const NEW_MIN_RESOURCE_UNITS = {
  [Resource.GPU]: 1,
  [Resource.CPU]: 8,
  [Resource.RAM]: 16,
  [Resource.STORAGE]: 100,
} as const;

export const FIZZ_NODE_NOT_FOUND_ERR_STRING = "FizzNodeNotFound";

export const REFERRAL_PERCENTAGE = 5 / 100;

export const BASE_REFERRAL_REWARD = 0.05;

export const NODE_UPDATE_INTERVAL =
  Number(process.env.NODE_UPDATE_INTERVAL) * 1000 * 60 * 60 ||
  1000 * 60 * 60 * 6; // 6 hour

export const ONBOARDING_VIDEOS: Record<
  OperatingSystem,
  { title: string; videoId: string }
> = {
  [OperatingSystem.Mac]: {
    title: "Step-by-Step Guide to Launch Your Fizz Node",
    videoId: "a1EoK91Cjzk",
  },
  [OperatingSystem.Linux]: {
    title: "Step-by-Step Guide to Launch Your Fizz Node",
    videoId: "a1EoK91Cjzk",
  },
  [OperatingSystem.Windows]: {
    title: "Step-by-Step Guide to Launch Your Fizz Node",
    videoId: "XPLvoVSsgwY",
  },
};

export const FIZZ_VERSION = "v1.6.0";
export const FIZZUP_VERSION = "v1.8.1";

export const MAX_FIZZ_NODE_COUNT_PER_PROVIDER = 3000;
export const MAX_ACTIVE_FIZZ_NODE_COUNT_PER_PROVIDER = 2000;

export const SKYNET_URL = "https://skynetxbt.ai";

export const DEFAULT_PARTNER_CODE = "STELLAR";

export const NEW_THRESHOLD_FIZZ_ID = 0;
export const DISABLE_CREATE_AND_UPDATE_NODE =
  process.env.NEXT_PUBLIC_DISABLE_CREATE_AND_UPDATE_NODE === "true";

export const thirdwebClient = createThirdwebClient({
  clientId: THIRD_WEB_CLIENT_ID || "",
});

export const LEADERBOARD_MAX_NODES_COUNT = Number(
  process.env.NEXT_PUBLIC_LEADERBOARD_MAX_NODES_COUNT || "100"
);
export const LEADERBOARD_PAGE_SIZE = Number(
  process.env.NEXT_PUBLIC_LEADERBOARD_PAGE_SIZE || "15"
);
